<template>
  <v-container fluid>
    <v-toolbar
      flat
      color="white"
    > 
      <v-row>
        <v-col
          class="py-0 mt-3"
          cols="12"
          lg="6"          
          md="12"
          sm="12"
          xl="4"
        >
          <v-text-field
            v-model="search"
            placeholder="Search EA Form"
            append-icon="search"
            label="Search file"
            hide-no-data
            hide-selected
            clearable 
          />
        </v-col>
      </v-row>
    </v-toolbar>    

    <v-data-table
      :headers="headers"
      :items="eaForms"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.file_name="{ item }">
        <div>
          <v-icon 
            class="mr-1"
            color="red"
          >
            mdi-file-pdf-box
          </v-icon>
          <a 
            :href="item.file_url + '?v=' + $moment().unix()" 
            target="_blank" 
          >
            {{ item.file_name }}
          </a>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn
          color="hrissuccess"
          dark
          icon
          medium
          @click="getDocument(item.file_url, item.file_name)"
        >
          <v-icon class="mr-1">
            mdi-download
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-row
      v-if="eaForms.length > 0"
      class="px-6 mt-n8 mb-2 red--text"
    >
      <v-icon
        class="pr-1"
        color="red"
      >
        mdi-information-outline
      </v-icon>
      <span v-if="currentPersonCitizenshipLookupUid && currentPersonCitizenshipLookupUid != (citizenship.find(e => e.value === 'MY').lookup_uid)">
        Kindly note that the EA form is safeguarded with a password. Kindly input the last six characters of your passport number for access.
      </span>
      <span v-else>Kindly note that the EA form is safeguarded with a password. Kindly input the last six digits of your IC number for access.</span>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        headers: [
          {
            text: 'File',
            align: 'left',
            value: 'file_name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        loading: false,
        eaForms: [],
        currentPersonCitizenshipLookupUid: '',
      }
    },
    computed: {
      ...mapState('lookup', ['citizenship']),
    },
    created () {
      this.loadData()
      this.loadCurrentPerson()
    },    
    methods: {    
      loadData () {
        this.$api.companyEmployeeDocuments().show(this.employeeUid + '?type=ea')
          .then(res => {
            res.data.company_employees.forEach(companyEmployee => {
              companyEmployee.company_employee_documents.forEach(document => {
                this.eaForms.push(document)
              })
            })
            
            this.eaForms = _.orderBy(this.eaForms, ['release_date'], ['desc'])
            this.tableLoading = false
          })
      },
      loadCurrentPerson () {
        const person = (JSON.parse(localStorage.getItem('user')) || {}).person || {}
        this.currentPersonCitizenshipLookupUid = person.citizenship_lookup_uid
      },
      getDocument (fileUrl, fileName) {
        fetch(fileUrl + '?v=' + this.$moment().unix())
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            const objectURL = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = objectURL
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            
            this.$snack({ message: 'EA form downloaded successfully.' })
          })
      }, 
    },
  }
</script>

<style scoped>
  a { 
    color: inherit; 
  }
</style>
